module.exports = __webpack_public_path__ + "img/6.a88f45a4.jpg";